<div class="d-flex flex-column items-resevations">
    <div class="header-info-reservations d-grid">
        <div class="col3 info-items">
            <p>{{ 'fe_precheckin_reservation_code' | translate }}</p>
            <p class="info_reservacion_data">
                <b>{{ reservation?.code }}</b>
            </p>
        </div>
        <div class="col4 info-items">
            <p>{{ 'fe_precheckin_reservation_vehicle_type' | translate }}</p>
            <p class="info_reservacion_data separator">
                <b>{{ reservation?.car?.name }}</b>
            </p>
        </div>
        <div class="col3 info-items d-none d-md-block">
            <button
                *ngIf="reservation.status !== 'CANCELED'"
                class="d-none d-md-flex"
                (click)="SelectReservation()"
            >
                <span>
                    {{
                        selected
                            ? ('fe_precheckin_reservation_selected' | translate)
                            : ('fe_precheckin_reservation_select' | translate)
                    }}
                </span>
                <img
                    class="add-icon"
                    alt="add-icon-img"
                    [src]="
                        selected
                            ? ('images/check_amarillo.svg' | cdn)
                            : ('images/mas.svg' | cdn)
                    "
                />
            </button>
            <p *ngIf="reservation.status === 'CANCELED'">
                {{
                    'fe_precheckin_active_reservation_active_reservation_status'
                        | translate
                }}
            </p>
            <p
                *ngIf="reservation.status === 'CANCELED'"
                class="info_reservacion_data separator"
            >
                <b>{{
                    'fe_details_step5_delivery_cancel_parent_top_title_canceled'
                        | translate
                }}</b>
            </p>
        </div>
    </div>
    <div class="body-info-reservations d-grid">
        <div class="info-items">
            <p class="text-uppercase info-title">
                <b>{{ 'fe_precheckin_reservation_office' | translate }}</b>
            </p>
            <p class="info-data">
                {{ reservation?.pickupBranch?.branchName }}
            </p>
            <p class="info-data">
                {{ reservation?.returnBranch?.branchName }}
            </p>
        </div>
        <div class="info-items">
            <p class="text-uppercase info-title">
                <b>{{ 'fe_precheckin_reservation_date' | translate }}</b>
            </p>
            <p class="info-subtitle">
                {{ 'fe_precheckin_reservation_pickup' | translate }}
            </p>
            <p class="info-data">
                {{
                    reservation?.pickupDate | formatDate: dateFormatProgressBar
                }}
            </p>
            <p class="info-subtitle">
                {{ 'fe_precheckin_reservation_return' | translate }}
            </p>
            <p class="info-data">
                {{
                    reservation?.returnDate | formatDate: dateFormatProgressBar
                }}
            </p>
            <p
                class="text-uppercase info-title fw-bold"
                *ngIf="reservation.status === 'CANCELED'"
            >
                {{
                    'fe_precheckin_active_reservation_active_reservation_status'
                        | translate
                }}
            </p>
            <p *ngIf="reservation.status === 'CANCELED'" class="info-data">
                {{
                    'fe_details_step5_delivery_cancel_parent_top_title_canceled'
                        | translate
                }}
            </p>
        </div>
    </div>
    <button
        *ngIf="reservation.status !== 'CANCELED'"
        class="d-flex d-md-none justify-content-center"
        (click)="SelectReservation()"
    >
        <span>
            {{
                selected
                    ? ('fe_precheckin_reservation_selected' | translate)
                    : ('fe_precheckin_reservation_select' | translate)
            }}
        </span>
        <img
            class="add-icon"
            alt="add-icon-img"
            [src]="
                selected
                    ? ('images/check_amarillo.svg' | cdn)
                    : ('images/mas.svg' | cdn)
            "
        />
    </button>
</div>
